import { Box } from "@material-ui/core";
import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import BarChart from "src/components/ScoringChart/BarChart";
import { FigureTypography } from "src/components/Typography/TitleTypography";
import OverviewMonitoringWrapper from "src/components/Wrapper/OverviewMonitoringWrapper";
import { MONITORING } from "src/config/constants";
import { useUserAnalysisChartSelector, useUserAnalysisSelector } from "src/context/monitoring/userAnalysisContext";
import { numberWithCommas } from "src/services/utils";

const getOption = () => ({
  chart: {
    height: 300,
  },
  yAxis: {
    tickAmount: 6,
    labels: {
      enabled: true,
    },
  },
  tooltip: {
    enabled: true,
  },
});

export default function NOURTransactionVolumeOverview() {
  const { pool } = useParams();
  const { fetchNOURTransactionVolume } = useUserAnalysisSelector((state) => state.fetch);
  const nourTransactionVolume = useUserAnalysisChartSelector(MONITORING.ANALYSIS.nourTransactionVolume, pool);

  useEffect(() => {
    fetchNOURTransactionVolume(pool);
  }, [pool]);

  const { categories, series, totalOfUsers, isLoading } = useMemo(() => {
    if (nourTransactionVolume?.tvl) {
      const { categories, data } = nourTransactionVolume.tvl;
      return {
        isLoading: false,
        totalOfUsers: data.reduce((x1, x2) => x1 + x2),
        categories: [].concat(categories),
        series: [
          {
            name: "Number Of User(Tvl)",
            data: [].concat(data),
          },
        ],
      };
    }
    return {
      isLoading: true,
      totalOfUsers: 0,
      categories: [],
      series: [],
    };
  }, [nourTransactionVolume]);

  return (
    <OverviewMonitoringWrapper
      isLoading={isLoading}
      title="Number Of Users Regarding Transaction Volume"
      overview="The chart shows the distributions of users according to their total value locked, deposit, or borrow in a lending pool."
      to={`/user-analysis/number-of-users-regarding-transaction-volume/${pool}`}
    >
      <Box display="flex" flexWrap="wrap">
        <FigureTypography value={numberWithCommas(totalOfUsers)} title="Total Of User" />
      </Box>
      <BarChart categories={categories} series={series} option={getOption()} />
    </OverviewMonitoringWrapper>
  );
}
